import { Document, Page, Text, View, pdf } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import { Header } from "./components/header/Header";
import { CustomerData } from "./components/customerData/CustomerData";
import { ShippingData } from "./components/shippingData/ShippingData";
import { PaymentData } from "./components/paymentData/PaymentData";
import { ProductsData } from "./components/productsData/ProductsData";
import { TransportationDocument } from "./components/transportationDocument/TransportationDocument";
import { RelatedCfdis } from "./components/relatedCfdis/RelatedCfdis";
import { BlankFooter } from "./components/blankFooter/BlankFooter";
import { generalStyles } from "./styles/generalStyles";
import { FooterInLastPage } from "./components/footerInLastPage/FooterInLastPage";
import { DeliverAndPaymentInfo } from "./components/deliveryAndPaymentInfo/DeliverAndPaymentInfo";
import { Destinations } from "./components/destinations/Destinations";

export const SalesInvoicePDF = () => {
  const { pageNumberAndTotalPages, pdfGenerationDate } =
    generalStyles();

  const [t, i18next] = useTranslation("global");

  let pages: number;
  let regex = /\([^)]*\)/g;;
  let fontFamily = "Noto Sans";

  const currentDate = new Date();

  const calculatePages = (totalProducts: number, productsPerPage: number, maxProductsWithFinalFooter: number) => {
    const remainingProducts = totalProducts % productsPerPage;

    return {
      needsExtraFooterPage: remainingProducts > 0 && remainingProducts > maxProductsWithFinalFooter,
    };
  };

  const generatePDF = async ({ data }: any) => {
    // const desiredLength = 10;
    // const repeatedData = [];

    // while (repeatedData.length < desiredLength) {
    //   repeatedData.push(...data?.invoiceDetails);
    // }

    // data.invoiceDetails = repeatedData.slice(0, desiredLength);

    const { needsExtraFooterPage } = calculatePages(data.invoiceDetails.length, 6, 3);

    // const generateDescription = (length: number) => {
    //   const lorem = "Lorem ipsum dolor sit amet consectetur adipiscing elit ".repeat(50);
    //   return lorem.slice(0, length).trim() + (length >= 1000 ? "..." : "");
    // };

    // data.invoiceDetails = data.invoiceDetails.map((item: any, index: number) => ({
    //   ...item,
    //   item_description: generateDescription([500, 300, 1200, 800, 1500][index % 5])
    // }));

    // if (
    //   !data.dataInvoiceGeneral.customer_language ||
    //   data.dataInvoiceGeneral.customer_language === " " ||
    //   data.dataInvoiceGeneral.customer_language.toLowerCase() === "es"
    // ) {
    //   data.dataInvoiceGeneral.customer_language = "es";
    // }

    // if (data.dataInvoiceGeneral.customer_language.toLowerCase() === "zh") {
    //   fontFamily = "Noto Sans SC";
    // }

    const showTranslatedText = (key: string) => {
      return t(key, {
        lng: data.dataInvoiceGeneral.customer_language.toLowerCase(),
      });
    };

    const content = (
      <Document>
        {/* Pagina con producto principales */}
        <Page size={"A4"}
          style={{
            paddingTop: data.dataInvoiceGeneral.includes_transportation_document ? 266 : 310,
            paddingBottom: 130,
            paddingHorizontal: 22,
            position: 'relative',
            fontFamily: fontFamily,
            fontWeight: 400
          }}
        >
          <Text
            render={({ pageNumber, totalPages }) => {
              pages = totalPages;
              return <Text></Text>;
            }}
            fixed
          />

          <View fixed style={{ position: 'absolute', top: 40, left: 22, right: 22 }} >
            <Header data={data} showTranslatedText={showTranslatedText} />

            {data.dataInvoiceGeneral.includes_transportation_document ? (
              <>
                <DeliverAndPaymentInfo
                  data={data}
                  showTranslatedText={showTranslatedText}
                />
              </>
            ) : (
              <>
                <CustomerData
                  data={data}
                  showTranslatedText={showTranslatedText}
                />

                <ShippingData
                  data={data}
                  showTranslatedText={showTranslatedText}
                />

                <PaymentData
                  data={data}
                  showTranslatedText={showTranslatedText}
                />
              </>
            )}
          </View>

          <View fixed>
            {data.dataInvoiceGeneral.includes_transportation_document &&
              <>
                <Destinations
                  data={data}
                  showTranslatedText={showTranslatedText}
                />
              </>
            }
          </View>

          <ProductsData
            data={data}
            showTranslatedText={showTranslatedText}
          />



          <View style={{ position: 'absolute', bottom: 40, left: 22, right: 22 }}
            render={({ pageNumber }: { pageNumber: number }) =>
              pageNumber < pages ?
                <BlankFooter
                  data={data}
                  showTranslatedText={showTranslatedText}
                />
                :
                <FooterInLastPage
                  data={data}
                  showTranslatedText={showTranslatedText}
                />
            }
            fixed
          />

          <Text
            style={pageNumberAndTotalPages.text}
            render={({ pageNumber, totalPages }) => {
              return <Text>{`Page ${pageNumber} / ${totalPages}`}</Text>;
            }}
            fixed
          />

          <Text style={pdfGenerationDate.text} fixed>
            {currentDate.toString().replace(regex, "").trim()}
          </Text>
        </Page>




        {/* Pagina con Documento de transporte */}
        {data.dataInvoiceGeneral.includes_transportation_document && (
          <Page size={"A4"}
            style={{
              paddingTop: data.dataInvoiceGeneral.includes_transportation_document ? 266 : 310,
              paddingBottom: 130,
              paddingHorizontal: 22,
              position: 'relative',
              fontFamily: fontFamily,
              fontWeight: 400
            }}
          >
            <Text
              render={({ pageNumber, totalPages }) => {
                pages = totalPages;
                return <Text></Text>;
              }}
              fixed
            />

            <View fixed style={{ position: 'absolute', top: 40, left: 22, right: 22 }} >
              <Header data={data} showTranslatedText={showTranslatedText} />

              {data.dataInvoiceGeneral.includes_transportation_document ? (
                <>
                  <DeliverAndPaymentInfo
                    data={data}
                    showTranslatedText={showTranslatedText}
                  />
                </>
              ) : (
                <>
                  <CustomerData
                    data={data}
                    showTranslatedText={showTranslatedText}
                  />

                  <ShippingData
                    data={data}
                    showTranslatedText={showTranslatedText}
                  />

                  <PaymentData
                    data={data}
                    showTranslatedText={showTranslatedText}
                  />
                </>
              )}
            </View>

            <View fixed>
              {data.dataInvoiceGeneral.includes_transportation_document &&
                <>
                  <Destinations
                    data={data}
                    showTranslatedText={showTranslatedText}
                  />
                </>
              }
            </View>



            {data.dataInvoiceGeneral.includes_transportation_document && (
              <>
                <TransportationDocument
                  data={data}
                  showTranslatedText={showTranslatedText}
                />
              </>
            )}

            {data.dataRelatedSalesInvoices && (
              <RelatedCfdis data={data} showTranslatedText={showTranslatedText} />
            )}

            <View style={{ position: 'absolute', bottom: 40, left: 22, right: 22 }}
              render={({ pageNumber }: { pageNumber: number }) =>
                pageNumber < pages && (
                  <BlankFooter
                    data={data}
                    showTranslatedText={showTranslatedText}
                  />
                )
              }
              fixed
            />

            <Text
              style={pageNumberAndTotalPages.text}
              render={({ pageNumber, totalPages }) => {
                return <Text>{`Page ${pageNumber} / ${totalPages}`}</Text>;
              }}
              fixed
            />

            <Text style={pdfGenerationDate.text} fixed>
              {currentDate.toString().replace(regex, "").trim()}
            </Text>
          </Page>
        )}







        {/* Pagina con footer final */}
        {(needsExtraFooterPage || data.dataInvoiceGeneral.includes_transportation_document) && (<Page size={"A4"}
          style={{
            paddingTop: data.dataInvoiceGeneral.includes_transportation_document ? 266 : 310,
            paddingBottom: 130,
            paddingHorizontal: 22,
            position: 'relative',
            fontFamily: fontFamily,
            fontWeight: 400
          }}
        >
          <Text
            render={({ pageNumber, totalPages }) => {
              pages = totalPages;
              return <Text></Text>;
            }}
            fixed
          />

          <View fixed style={{ position: 'absolute', top: 40, left: 22, right: 22 }} >
            <Header data={data} showTranslatedText={showTranslatedText} />

            {data.dataInvoiceGeneral.includes_transportation_document ? (
              <>
                <DeliverAndPaymentInfo
                  data={data}
                  showTranslatedText={showTranslatedText}
                />

              </>
            ) : (
              <>
                <CustomerData
                  data={data}
                  showTranslatedText={showTranslatedText}
                />

                <ShippingData
                  data={data}
                  showTranslatedText={showTranslatedText}
                />

                <PaymentData
                  data={data}
                  showTranslatedText={showTranslatedText}
                />
              </>
            )}
          </View>

          <View fixed>
            {data.dataInvoiceGeneral.includes_transportation_document &&
              <>
                <Destinations
                  data={data}
                  showTranslatedText={showTranslatedText}
                />
              </>
            }
          </View>




          <View style={{ position: 'absolute', bottom: 40, left: 22, right: 22 }}
            render={({ pageNumber }: { pageNumber: number }) =>
              pageNumber < pages && (
                <BlankFooter
                  data={data}
                  showTranslatedText={showTranslatedText}
                />
              )
            }
            fixed
          />

          <View style={{ position: 'absolute', bottom: 40, left: 22, right: 22 }}>
            <FooterInLastPage
              data={data}
              showTranslatedText={showTranslatedText}
            />
          </View>

          <Text
            style={pageNumberAndTotalPages.text}
            render={({ pageNumber, totalPages }) => {
              return <Text>{`Page ${pageNumber} / ${totalPages}`}</Text>;
            }}
            fixed
          />

          <Text style={pdfGenerationDate.text} fixed>
            {currentDate.toString().replace(regex, "").trim()}
          </Text>
        </Page>)}

      </Document>
    );

    const downloadLink = document.createElement("a");
    const fileName = `${data.dataInvoiceGeneral?.sales_invoice_name || " "}`;
    const blob = await pdf(content).toBlob();
    const url = URL.createObjectURL(blob);
    downloadLink.href = url;
    downloadLink.download = fileName;
    downloadLink.click();
    URL.revokeObjectURL(url);

    const reader = new FileReader();
    await reader.readAsDataURL(blob);

    return new Promise((resolve, reject) => {
      reader.onloadend = () => {
        const base64String = reader.result;
        resolve(base64String);
      };
    });
  };

  return {
    generatePDF,
  };
};
